/* eslint-disable */
/* This file is generated by the `djrun` shortcut in vagrant, and has to be commited to the repo. */
let urls = (function () {
    "use strict";
    var data = {"urls": [["accounts_pending", [["accounts/pending/", []]]], ["django-admindocs-bookmarklets", [["admin/doc/bookmarklets/", []]]], ["django-admindocs-docroot", [["admin/doc/", []]]], ["django-admindocs-filters", [["admin/doc/filters/", []]]], ["django-admindocs-models-detail", [["admin/doc/models/%(app_label)s.%(model_name)s/", ["app_label", "model_name"]]]], ["django-admindocs-models-index", [["admin/doc/models/", []]]], ["django-admindocs-tags", [["admin/doc/tags/", []]]], ["django-admindocs-templates", [["admin/doc/templates/%(template)s/", ["template"]]]], ["django-admindocs-views-detail", [["admin/doc/views/%(view)s/", ["view"]]]], ["django-admindocs-views-index", [["admin/doc/views/", []]]], ["django_registration_activation_complete", [["accounts/activate/complete/", []]]], ["frontend_map", [["map/", []]]], ["frontend_map_site", [["map/site/%(site_id)s/", ["site_id"]]]], ["frontend_map_site_popup", [["map/%(site_id)s/", ["site_id"]]]], ["frontend_saved_map", [["saved-maps/%(slug)s/", ["slug"]]]], ["frontend_saved_map_gss_code", [["saved-maps/%(slug)s/%(gss_code)s/", ["slug", "gss_code"]]]], ["frontend_saved_map_nffs", [["saved-maps/nffs-org-type-%(org_type)s-facility-type-%(facility_type)s-funding-cycle-%(funding_cycle)s-nffs-%(nffs)s-lffp-%(lffp)s/", ["org_type", "facility_type", "funding_cycle", "nffs", "lffp"]]]], ["frontend_saved_map_nffs_gss_code", [["saved-maps/nffs-org-type-%(org_type)s-facility-type-%(facility_type)s-funding-cycle-%(funding_cycle)s-nffs-%(nffs)s-lffp-%(lffp)s/%(gss_code)s/", ["org_type", "facility_type", "funding_cycle", "nffs", "lffp", "gss_code"]]]], ["frontend_saved_maps", [["saved-maps/", []]]], ["login", [["accounts/login/", []]]], ["logout", [["accounts/logout/", []]]], ["mapping:add_pitchfinder_widget", [["add-pitchfinder-widget/", []]]], ["mapping:api_name_for_id", [["api/name/", []]]], ["mapping:api_postcode_search", [["api/search/postcode/", []]]], ["mapping:api_saved_map", [["api/frontend/saved_maps/%(slug)s/", ["slug"]]]], ["mapping:api_saved_map_delete", [["api/frontend/saved_maps/%(slug)s/delete/", ["slug"]]]], ["mapping:api_saved_map_nffs", [["api/frontend/saved_maps/nffs-org-type-%(org_type)s-facility-type-%(facility_type)s-funding-cycle-%(funding_cycle)s-nffs-%(nffs)s-lffp-%(lffp)s/", ["org_type", "facility_type", "funding_cycle", "nffs", "lffp"]]]], ["mapping:api_saved_map_update", [["api/frontend/saved_maps/%(slug)s/update/", ["slug"]]]], ["mapping:api_saved_maps", [["api/frontend/saved_maps/", []]]], ["mapping:config", [["api/frontend/config/", []]]], ["mapping:field_values", [["api/frontend/field_values/%(lookup_id)s/", ["lookup_id"]]]], ["mapping:filter_sites", [["api/frontend/filter_sites/", []]]], ["mapping:frontend_map_site_popup_redirect", [["%(site_id)s/", ["site_id"]]]], ["mapping:get_point_and_areas", [["api/frontend/get_point_and_areas/", []]]], ["mapping:initial_data", [["api/frontend/initial/", []]]], ["mapping:investments_in_la", [["api/investments-in-la/%(la_gss_code)s/", ["la_gss_code"]]]], ["mapping:landing_page_redirect", [["%(slug)s/", ["slug"]]]], ["mapping:list_view_redirect", [["search/", []]]], ["mapping:main_search_autocomplete", [["api/frontend/main_search_autocomplete/", []]]], ["mapping:openactive-sites-list", [["api/v0/openactive/sites/", []]]], ["mapping:related_objects", [["api/frontend/related_objects/%(lookup_id)s/", ["lookup_id"]]]], ["mapping:saved_search_list_redirect", [["saved-search/", []]]], ["mapping:saved_search_redirect", [["saved-search/%(slug)s/%(gss_code_override)s/", ["slug", "gss_code_override"]], ["saved-search/%(slug)s/", ["slug"]]]], ["mapping:set_update_status", [["set_update_status/%(token)s/%(site_id)s/%(status)s/", ["token", "site_id", "status"]]]], ["mapping:site_detail", [["api/site/%(site_id)s/", ["site_id"]]]], ["mapping:site_detail_full", [["api/site/%(site_id)s/full/", ["site_id"]]]], ["mapping:site_detail_redirect", [["detail/%(site_id)s/", ["site_id"]]]], ["mapping:site_detail_skipcache", [["api/site/%(site_id)s/skipcache/", ["site_id"]]]], ["mapping:site_info", [["api/frontend/site_info/%(site_id)s/", ["site_id"]]]], ["mapping:site_selector_test", [["site_selector_test/", []]]], ["mapping:site_selector_ui", [["site_selector_ui/", []]]], ["mapping:site_selector_widget_redirect", [["static/js/site_selector.js", []]]], ["mapping:sites_within_catchment_area", [["api/sites_within_catchment_area/", []]]], ["mapping:teams_in_la", [["api/teams-in-la/%(la_gss_code)s/", ["la_gss_code"]]]], ["mapping:widget_redirect", [["static/widget/", []]]], ["password_change", [["accounts/password/change/", []]]], ["password_change_done", [["accounts/password/change/done/", []]]], ["password_reset", [["accounts/password/reset/", []]]], ["password_reset_complete", [["accounts/password/reset/complete/", []]]], ["password_reset_confirm", [["accounts/password/reset/confirm/%(uidb64)s/%(token)s/", ["uidb64", "token"]]]], ["password_reset_done", [["accounts/password/reset/done/", []]]], ["process_pending_account", [["accounts/process_pending/%(pending_id)s/", ["pending_id"]]]], ["register", [["accounts/register/", []]]], ["registration_activate", [["accounts/activate/key/%(activation_key)s/", ["activation_key"]]]], ["reject_pending_account", [["accounts/reject_pending/%(pending_id)s/", ["pending_id"]]]], ["wgs:new_site", [["wgs/newsite/", []]]], ["wgs:new_site_submitted", [["wgs/newsite/submitted/%(token)s/", ["token"]]]], ["wgs:token_check", [["wgs/api/token/%(token)s/", ["token"]]]]], "prefix": "/"};
    function factory(d) {
        var url_patterns = d.urls;
        var url_prefix = d.prefix;
        var Urls = {};
        var self_url_patterns = {};

        var _get_url = function (url_pattern) {
        return function () {
            var _arguments, index, url, url_arg, url_args, _i, _len, _ref,
            _ref_list, match_ref, provided_keys, build_kwargs;

            _arguments = arguments;
            _ref_list = self_url_patterns[url_pattern];

            if (arguments.length == 1 && typeof (arguments[0]) == "object") {
            // kwargs mode
            var provided_keys_list = Object.keys (arguments[0]);
            provided_keys = {};
            for (_i = 0; _i < provided_keys_list.length; _i++)
                provided_keys[provided_keys_list[_i]] = 1;

            match_ref = function (ref)
            {
                var _i;

                // Verify that they have the same number of arguments
                if (ref[1].length != provided_keys_list.length)
                return false;

                for (_i = 0;
                 _i < ref[1].length && ref[1][_i] in provided_keys;
                 _i++);

                // If for loop completed, we have all keys
                return _i == ref[1].length;
            }

            build_kwargs = function (keys) {return _arguments[0];}

            } else {
            // args mode
            match_ref = function (ref)
            {
                return ref[1].length == _arguments.length;
            }

            build_kwargs = function (keys) {
                var kwargs = {};

                for (var i = 0; i < keys.length; i++) {
                kwargs[keys[i]] = _arguments[i];
                }

                return kwargs;
            }
            }

            for (_i = 0;
             _i < _ref_list.length && !match_ref(_ref_list[_i]);
             _i++);

            // can't find a match
            if (_i == _ref_list.length)
            return null;

            _ref = _ref_list[_i];
            url = _ref[0], url_args = build_kwargs(_ref[1]);
            for (url_arg in url_args) {
            var url_arg_value = url_args[url_arg];
            if (url_arg_value === undefined || url_arg_value === null) {
                url_arg_value = '';
            } else {
                url_arg_value = url_arg_value.toString();
            }
            url = url.replace("%(" + url_arg + ")s", url_arg_value);
            }
            return url_prefix + url;
        };
        };

        var name, pattern, url, _i, _len, _ref;
        for (_i = 0, _len = url_patterns.length; _i < _len; _i++) {
        _ref = url_patterns[_i], name = _ref[0], pattern = _ref[1];
        self_url_patterns[name] = pattern;
        url = _get_url(name);
        Urls[name.replace(/[-_]+(.)/g, function (_m, p1) { return p1.toUpperCase(); })] = url;
        Urls[name.replace(/-/g, '_')] = url;
        Urls[name] = url;
        }

        return Urls;
    }
    return data ? factory(data) : factory;
})();

        // Make url namespaces nicer: urls['mapping:detail']() -> urls.mapping.detail()
        Object.keys(urls).forEach(function(key){
            const bits = key.split(':');
            let current_namespace;

            bits.forEach(function(bit, i){
                if(!current_namespace){
                    current_namespace = urls;
                }
                if (i == bits.length - 1) {
                    current_namespace[bit] = urls[key];
                }else{
                    current_namespace = current_namespace[bits[i]] = current_namespace[bit] || {};
                }
            });

            if (bits.length > 1) {
                delete urls[key];
            }
        });

        export default urls;
        